<div class="header-search flex jc-sb">
    <div class="flex wrapper">
        <div>
            <div class="dark-light uppercase mapfre-fs-s-r mapfre-mt-s mapfre-hide-mobile mapfre-hide-tablet">
                {{itemName | titlecase}}
            </div>
        </div>
        <div class="header-search__divider"></div>
        <div>
            <div class="dark-light mapfre-fs-s-r mapfre-mt-s flex uppercase">
                {{address}}
                <div (click)="onChangeSearch()" class="primary change-link
                mapfre-hide-desktop
                capitalize
                mapfre-fs-xs
                mapfre-ml-s
                flex cp as-e"> {{
                    'HEADER_SEARCH.CHANGE_LINK' |
                    translate | titlecase}}
                </div>
                <img (click)="ui.openFilterModal()" class="mapfre-mr-xs filter-link mapfre-hide-desktop"
                    src="assets/icons/filter-primary.svg" alt="">
            </div>

        </div>
        <div (click)="onChangeSearch()" class="primary
        mapfre-hide-tablet
        mapfre-hide-mobile mapfre-mt-xxs mapfre-fs-xs mapfre-ml-xsm mapfre-mr-sm flex cp capitalize as-c"> {{
            'HEADER_SEARCH.CHANGE_LINK' |
            translate | titlecase}}
        </div>
    </div>
    <div class="flex ai-c
    mapfre-hide-tablet
    mapfre-hide-mobile">
        <div class="gray1 mapfre-fs-s mapfre-mt-s">
            <strong>{{getTotalResultLabel()}}</strong>
        </div>
    </div>

</div>
